import { render, staticRenderFns } from "./PdpProductImageZoom.vue?vue&type=template&id=354e63c4&scoped=true&"
import script from "./PdpProductImageZoom.vue?vue&type=script&lang=js&"
export * from "./PdpProductImageZoom.vue?vue&type=script&lang=js&"
import style0 from "./PdpProductImageZoom.vue?vue&type=style&index=0&id=354e63c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e63c4",
  null
  
)

export default component.exports